/* import __COLOCATED_TEMPLATE__ from './company-posting-module.hbs'; */
import Component from '@glimmer/component';

class MyNetworkModuleComponent extends Component {
  get showDefaultState() {
    const { companyPostingStats } = this.args;
    if (!companyPostingStats) return true;
    return companyPostingStats.hiresMade === 0
      && companyPostingStats.applicationsAwaitingReview === 0
      && companyPostingStats.livePostings === 0;
  }
}

export default MyNetworkModuleComponent;
